const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

const companyInfo = r =>
  require.ensure(
    [],
    () => r(require('@/modules/tenantManager/CompanyInfo.vue')),
    'CompanyInfo'
  )

const companyDetails = r =>
  require.ensure(
    [],
    () => r(require('@/modules/tenantManager/companyInfo/companyDetail.vue')),
    'CompanyInfo'
  )
const employeeDetail = r =>
  require.ensure(
    [],
    () => r(require('@/modules/tenantManager/companyInfo/employeeDetail.vue')),
    'CompanyInfo'
  )

const tenant = [
  {
    path: '/tenantManager',
    name: 'tenantManager',
    component: Layout,
    meta: {
      id: '348bcd0d2c2e46b584dbc83d51a3b0f7',
      auth: true
    },
    redirect: '/tenantManager/companyInfo',
    children: [
      {
        path: '/tenantManager/companyInfo',
        name: 'tenantCompanyInfo',
        component: companyInfo,
        meta: {
          id: '394906f1c7e94730a17a40606913c290',
          auth: true,
          asParams: true,
          showApp: true,
          showAll: true
        }
      },
      {
        path: '/tenantManager/companyDetails',
        name: 'companyDetails',
        component: companyDetails,
        hidden: true,
        meta: {
          id: 'c478414c60e6430483d43b0b3f33fd5a',
          auth: true
        }
      },
      {
        path: '/tenantManager/employeeDetail',
        name: 'employeeDetail',
        component: employeeDetail,
        hidden: true,
        meta: {
          id: '8f5a5df4a10c40bbba2b2ac6dd6a8b25',
          auth: true
        }
      }
    ]
  }
]
export default tenant



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/tenantManager.js